import dayjs from "dayjs";

export const normalizeDateForUpdate4D = (value) => {
  if (!value) return null;

  if (typeof value === "string") {
    return value.slice(0, 10);
  }

  const parsed = dayjs(value);

  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
};

export const buildUpdate4DBodyFromTask = (task) => {
  return {
    actualStart: normalizeDateForUpdate4D(
      task?.actualStart || task?.startDate || task?.plannedStart
    ),
    actualEnd: normalizeDateForUpdate4D(
      task?.actualEnd || task?.endDate || task?.plannedEnd || task?.actualFinish
    ),
    progress: Number.isNaN(Number(task?.progress)) ? 0 : Number(task.progress),
    manhours: Number.isNaN(
      Number(
        task?.manhours ??
          task?.actualHours ??
          task?.hours ??
          task?.actualHrDollar
      )
    )
      ? 0
      : Number(
          task?.manhours ??
            task?.actualHours ??
            task?.hours ??
            task?.actualHrDollar
        ),
  };
};

export const hasValidUpdate4DBody = (body) => {
  return (
    body &&
    body.actualStart &&
    body.actualEnd &&
    body.progress !== undefined &&
    body.manhours !== undefined
  );
};

export const build4DSyncBatchKey = (tasksToSync4D) => {
  if (!Array.isArray(tasksToSync4D)) return "";

  return tasksToSync4D
    .map(({ task, body }) => {
      return [
        task?.id,
        task?.taskCode,
        body?.actualStart,
        body?.actualEnd,
        body?.progress,
        body?.manhours,
      ].join("|");
    })
    .join("::");
};
